import React, { useState } from "react";
import { PackageResponse } from "../../../app/models/responseModels/packageResponse";
import FullScreenModal from "../../../components/common/modalPopup/FullScreenModal";
import { Box, Grid } from "@mui/material";
import MuiTabs, { TabsDetails } from "../../../components/common/tabs/MuiTabs";
import PackageDetails from "../PackageDetails";
import PackageEvents from "../PackageEvents";

interface EditPackageModalProps {
  closeEditPackageModal: CallableFunction;
  onCompleted: CallableFunction;
  packageRowData: PackageResponse;
}

const EditPackageModal = ({
  closeEditPackageModal,
  onCompleted,
  packageRowData,
}: EditPackageModalProps) => {
  const [showSubmitButton, setShowSubmitButton] = useState(false);

  const tabsValues: TabsDetails[] = [
    {
      tabName: "General",
      tabContent: <PackageDetails packageRowData={packageRowData} />,
      index: 0,
    },
    {
      tabName: "Events",
      tabContent: <PackageEvents packageRowData={packageRowData} />,
      index: 1,
    },
  ];

  const handleSubmit = async () => {
    return true;
  };

  return (
    <>
      <FullScreenModal
        title="Edit Package"
        updateAsyncOperation={handleSubmit}
        closeFullScreenModal={closeEditPackageModal}
        isLoading={false}
        closeModalAfterSubmit={true}
        confirmMessage="Are you sure you want to delete?"
        isUpdatePermission={true}
        isDeletePermission={false}
        setShowSubmitButton={setShowSubmitButton}
        showSubmitButton={showSubmitButton}
        showDeleteButton={false}
        showEditButton= {true}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Grid container rowSpacing={2} columnSpacing={2}>
            <MuiTabs tabDetails={tabsValues} />
          </Grid>
        </Box>
      </FullScreenModal>
    </>
  );
};

export default EditPackageModal;
